import { ApiFilestackImageWithTextData } from 'api/types/ApiFilestackImageData';
import { FilestackImage } from 'components/FilestackImage/FilestackImage';
import { imageUrl } from 'utils/filestack';

import { GifImage, ImageContainer } from './CmsImageBlockImage.styled';

type Props = {
  image: ApiFilestackImageWithTextData;
  keepDimensions: boolean;
  fullWidthLayout: boolean;
};

export function CmsImageBlockImage({
  image,
  keepDimensions,
  fullWidthLayout,
}: Props) {
  const { mimetype, handle, altText } = image;
  const isGif = mimetype === 'image/gif';

  if (isGif) {
    return (
      <GifImage
        src={imageUrl({ handle, mimetype })}
        alt={altText || ''}
        $fullWidthLayout={fullWidthLayout}
      />
    );
  }

  return (
    <ImageContainer keepDimensions={keepDimensions}>
      <FilestackImage
        data-qa-id="cms-image-block-image"
        data={image}
        alt={altText || ''}
        width={keepDimensions ? undefined : 1152}
        objectPosition="left"
        insecureSVG
      />
    </ImageContainer>
  );
}
